module.exports = __webpack_public_path__ + "img/equipment-coin.cd35ee9.webp";